import React, { useState, useEffect, useRef } from 'react';
import { FiMapPin, FiSearch, FiX } from 'react-icons/fi';
import './LocationSelector.css';

const LocationSelector = ({
  label,
  placeholder,
  icon,
  locations = [],
  value,
  excludeId,
  onChange,
}) => {
  const [query, setQuery] = useState('');
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const handler = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, []);

  const filtered = locations.filter(
    (loc) =>
      loc._id !== excludeId &&
      loc.location_name.toLowerCase().includes(query.toLowerCase())
  );

  const select = (loc) => {
    onChange({
      id: loc._id,
      name: loc.location_name,
      latitude: loc.latitude,
      longitude: loc.longitude,
    });
    setQuery('');
    setOpen(false);
  };

  const clear = () => {
    onChange({ id: '', name: '', latitude: null, longitude: null });
    setQuery('');
  };

  return (
    <div className="ls-wrap" ref={ref}>
      <label className="ls-label">{label}</label>
      <div className={`ls-input ${open ? 'open' : ''}`}>
        <span className="ls-icon">{icon || <FiMapPin />}</span>
        <input
          type="text"
          placeholder={placeholder}
          value={query || value?.name || ''}
          onChange={(e) => {
            setQuery(e.target.value);
            setOpen(true);
          }}
          onFocus={() => setOpen(true)}
        />
        {value?.name && (
          <button type="button" className="ls-clear" onClick={clear} aria-label="Clear">
            <FiX />
          </button>
        )}
      </div>

      {open && (
        <ul className="ls-dropdown">
          {filtered.length === 0 ? (
            <li className="ls-empty">
              <FiSearch /> No locations found
            </li>
          ) : (
            filtered.map((loc) => (
              <li
                key={loc._id}
                className="ls-option"
                onClick={() => select(loc)}
              >
                <FiMapPin className="ls-opt-icon" />
                <span>{loc.location_name}</span>
              </li>
            ))
          )}
        </ul>
      )}
    </div>
  );
};

export default LocationSelector;